module.exports = __webpack_public_path__ + "img/paso3.50826b4e.png";